<template>
  <div class="">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
      class="demo-ruleForm"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('product.form.projectName')" prop="name">
            <el-input
              v-model="ruleForm.name"
              :placeholder="$t('product.form.pleaseEnterProjectName')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('product.form.freightClass')" prop="freight_class">
            <el-select
              v-model="ruleForm.freight_class"
              :placeholder="$t('product.form.pleaseSelectFreightClass')"
              style="width: 100%"
            >
              <el-option v-for="(item,index) in classList" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('product.form.length')" prop="length">
            <el-input
              v-model.number="ruleForm.length"
              :controls='false'
              :min="0"
              :placeholder="$t('product.form.pleaseEnterLength')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('product.form.width')" prop="width">
            <el-input
              v-model.number="ruleForm.width"
              :placeholder="$t('product.form.pleaseEnterWidth')"
              :controls='false'
              :min="0"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('product.form.height')" prop="height">
            <el-input
              v-model.number="ruleForm.height"
              :placeholder="$t('product.form.pleaseEnterHeight')"
              :controls='false'
              :min="0"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('product.form.weight')" prop="weight">
            <el-input
              v-model.number="ruleForm.weight"
              :placeholder="$t('product.form.pleaseEnterWeight')"
              :controls='false'
              :min="0"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('product.form.palletType')" prop="battering_type">
            <el-select
              v-model="ruleForm.battering_type"
              :placeholder="$t('product.form.pleaseSelectPalletType')"
              style="width: 100%"
            >
              <el-option v-for="(item, index) in battList" :key="index" :label="item.name" :value="item.id.toString()" ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('product.form.productUnit')" prop="product_unit">
            <el-select
              v-model="ruleForm.product_unit"
              :placeholder="$t('product.form.pleaseSelectProductUnit')"
              style="width: 100%"
            >
              <el-option v-for="(item, index) in unitList" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width="150px" :label="$t('product.form.cargoCategoryCode')">
            <el-input
              :placeholder="$t('product.form.pleaseEnterCargoCategoryCode')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width="150px" :label="$t('product.form.subcategoryCode')">
            <el-input
              :placeholder="$t('product.form.pleaseEnterSubcategoryCode')"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- <el-form-item prop="isDefault">
        <el-checkbox
          v-model="ruleForm.isDefault"
          :checked="ruleForm.is_default == 1 ? true : false"
          :true-label="1"
          :false-label="0"
          name="isDefault"
          >{{ $t('product.form.setAsDefaultAddress') }}</el-checkbox>
      </el-form-item> -->
      <el-form-item style="text-align: right">
        <el-button size="small" type="primary" @click="submitForm('ruleForm')"
          >{{ $t('product.form.submit') }}</el-button>
        <el-button size="small" @click="resetForm('ruleForm')">{{ $t('product.form.reset') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { productAdd, productUpdate } from "@/api/ltl/product";
import { validatenull, freightLevel, JudgePalletTypeArr, productUnit } from "@/common/common.js";
export default {
  props: {
    record: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      ruleForm: {},
      rules: {
        name: [{ required: true, message: this.$t('product.form.pleaseEnterProjectName'), trigger: "blur" }],
        length: [{ required: true, message: this.$t('product.form.pleaseEnterLength'), trigger: "blur" }],
        width: [{ required: true, message: this.$t('product.form.pleaseEnterWidth'), trigger: "blur" }],
        height: [{ required: true, message: this.$t('product.form.pleaseEnterHeight'), trigger: "blur" }],
        weight: [{ required: true, message: this.$t('product.form.pleaseEnterWeight'), trigger: "blur" }],
      },
      id: "",
      classList: freightLevel(),
      battList: JudgePalletTypeArr(),
      unitList: productUnit()
    };
  },
  mounted() {
    if (!validatenull(this.record)) {
      this.id = this.record.id;
      this.ruleForm = {
        ...this.record,
        product_unit: this.record.product_unit > 0 ? this.record.product_unit : ''
      };
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let form = this.ruleForm;
          if (this.id) {
            productUpdate({
              id: this.id,
              u_id: JSON.parse(window.localStorage.getItem("userInfo1")).user_id,
              ...form,
            })
              .then((res) => {
                if (res.code == 1) {
                  this.$message.success(res.msg);
                  this.$emit("ok");
                } else {
                  this.$message.error(res.msg);
                }
              })
              .catch((err) => {
                this.$message.error(err.msg);
              });
          } else {
            productAdd({
              u_id: JSON.parse(window.localStorage.getItem("userInfo1")).user_id,
              ...form,
            })
              .then((res) => {
                if (res.code == 1) {
                  this.$message.success(res.msg);
                  this.$emit("ok");
                } else {
                  this.$message.error(res.msg);
                }
              })
              .catch((err) => {
                this.$message.error(err.msg);
              });
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm = {};
    },
  },
};
</script>
<style lang="scss" scoped>
  /deep/ input::-webkit-outer-spin-button,
  /deep/ input::-webkit-inner-spin-button {
    -webkit-appearance: none!important;
  }
</style>